import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { NZ_I18N, en_US, it_IT } from 'ng-zorro-antd/i18n';
import { MaterialModule, UiModule, ZorroModule } from '@menatcode/purpletree';
import { CommonModule } from './common/common.module';
import { AllAppsComponent } from './features/all-apps/all-apps.component';
import { CacheInterceptor } from './common/interceptors/cache.interceptor';
import { AuthInterceptor } from './common/auth/auth.interceptor';
import { ErrorInterceptor } from './common/interceptors/error.interceptor';

import { LoaderInterceptor } from './common/interceptors/loader.interceptor';
import { MessageInterceptor } from './common/interceptors/message.interceptor';
import {BreadcrumbModule} from "xng-breadcrumb";
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import {LottieModule} from "ngx-lottie";
import it from '@angular/common/locales/en';

registerLocaleData(it);

@NgModule({
    declarations: [
        AppComponent,
        AllAppsComponent,
        PageNotFoundComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ZorroModule,
        CommonModule,
        MaterialModule,
        UiModule,
        BreadcrumbModule,
        LottieModule,
    ],
    providers: [
        { provide: NZ_I18N, useValue: it_IT },
        { provide: LOCALE_ID, useValue: "it-IT" },
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true, },
        { provide: HTTP_INTERCEPTORS, useClass: MessageInterceptor, multi: true, }
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule {
}
